import { render, staticRenderFns } from "./playerCard.vue?vue&type=template&id=7c75362a&scoped=true"
import script from "./playerCard.vue?vue&type=script&lang=js"
export * from "./playerCard.vue?vue&type=script&lang=js"
import style0 from "./playerCard.vue?vue&type=style&index=0&id=7c75362a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c75362a",
  null
  
)

export default component.exports